<template>
  <q-dialog :visible="isVisible" title="暂缓上架" width="500px" @close="onCancel" :innerScroll="false" :loading="loadingBtn" @cancel="onCancel" @confirm="onConfirm">
    <div class="unable-listing-container">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" label-position="left">
        <el-form-item label="下架到" prop="state" size="mini">
          <el-radio-group v-model="form.state" @input="restForm">
            <el-radio :label="0">待上架</el-radio>
            <el-radio :label="1">暂缓上架</el-radio>
            <el-radio :label="2">无需上架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="暂缓上架原因" prop="reasonType" size="mini" v-if="form.state === 1">
          <el-radio-group v-model="form.reasonType">
            <el-radio :label="1">发货周期不满足</el-radio>
            <el-radio :label="2">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.state === 1 && form.reasonType !== 2" label="平台限制天数" prop="limitDays">
          <el-select v-model="form.limitDays" placeholder="请选择" size="mini">
            <el-option v-for="item in sendCycleList" :key="item.confValue" :label="item.confName" :value="item.confName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.state === 0 || form.state == 2 || form.reasonType === 2" label="原因描述" prop="reason">
          <el-input v-model="form.reason" type="textarea" placeholder="请输入" :autosize="{minRows: 6, maxRows: 6 }" size="mini"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </q-dialog>
</template>

<script>
import axios from '@/utils/axiosInstance';
export default {
  name: 'UnableListing',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    ids: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      form: {
        state: '',
        reasonType: '',
        reasonDesc: '',
        limitDays: '',
      },
      rules: {
        state: [{ required: true, message: '不能为空', trigger: 'change' }],
        reasonType: [{ required: true, message: '不能为空', trigger: 'change' }],
        reason: [{ required: true, message: '不能为空', trigger: 'blur' }],
        limitDays: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      sendCycleList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  mounted() {
    this.getSendCycleList()
  },
  methods: {
    getSendCycleList() {
      let data = { ...this.currencyForm };
      data.reportCode = 'sendCycle';
      axios.post(`/ec-pc-api/custom/reports/data/sendCycle`, data).then((res) => {
        if (res.code == 200) {
          this.sendCycleList = res.data.list.filter((v) => v.categoryCode == 'sendCycle');
        }
      });
    },
    restForm() {
      this.$refs.formRef.clearValidate()
    },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loadingBtn = true;
        let data = {
          id: this.ids,
          state: this.form.state,
          reason: this.form.reasonType === 1 ? this.form.limitDays : this.form.reason,
        };
        this.$q.newProduct
          .productListUpDown({data : data})
          .then((res) => {
            if (res.success) {
              this.$message.success('操作成功');
              this.$emit('getNewTab');
              this.onCancel();
            } else {
              this.$message.error(res.message || '操作失败');
            }
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.unable-listing-container
  padding: 20px

>>> .el-input--mini .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 200px !important;

>>> .el-input
  width 200px !important;
</style>
